$(function () {

	var $body = $('body');

	//ページ内スクロール
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top - 80;
		$('body,html').animate({scrollTop:position}, speed);
		console.log(position);
		return false;
	});

	$('body')
		.delay(600)
		.queue(function () {
			$(this).addClass('body-loaded').dequeue();
		});


		//加盟店の声スライド(スマホのみ)
	var voice_swiper;
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			if (voice_swiper) {
				return;
			} else {
				voice_swiper = new Swiper('.voice_swiper', {
					loop: true,
					// autoplay: {
					// 	delay: 4000,
					// },
					spaceBetween: 19,
					slidesPerView: 1,
					centeredSlides: true,
					pagination: {
						el: '.swiper-pagination-1',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next-1',
						prevEl: '.swiper-button-prev-1',
					}
				});
			}
		} else {
			if (voice_swiper) {
				voice_swiper.destroy();
				voice_swiper = undefined;
			}
		}
	});

	//加盟店の声スライド(スマホのみ)
	var sales_swiper;
	$(window).on('load resize', function(){
		var w = $(window).width();
		if (w <= 768) {
			if (sales_swiper) {
				return;
			} else {
				sales_swiper = new Swiper('.sales_swiper', {
					loop: true,
					// autoplay: {
					// 	delay: 4000,
					// },
					spaceBetween: 20,
					slidesPerView: 1,
					centeredSlides: true,
					pagination: {
						el: '.swiper-pagination-2',
						clickable: true,
					},
					navigation: {
						nextEl: '.swiper-button-next-2',
						prevEl: '.swiper-button-prev-2',
					}
				});
			}
		} else {
			if (sales_swiper) {
				sales_swiper.destroy();
				sales_swiper = undefined;
			}
		}
	});

$(document).on("click", "#privacy_text", function () {
  document.getElementById("privacy_modal").classList.add("--active");
  document
    .getElementById("privacy_overlay")
    .addEventListener("touchmove", disableScroll, { passive: false });
  document
    .getElementById("privacy_overlay")
    .addEventListener("mousewheel", disableScroll, { passive: false });
	return false;
});

$(document).on("click", "#privacy_overlay", function () {
  document.getElementById("privacy_modal").classList.remove("--active");
});

$(document).on("click", ".close-btn", function () {
  document.getElementById("privacy_modal").classList.remove("--active");
});

function disableScroll(event) {
  event.preventDefault();
}

	//フォーム郵便番号
	$('.input_half_button').on('click', function(){
		AjaxZip3.zip2addr( 'your-zip', '', 'your-prefecture', 'your-address' );
		//成功時に実行する処理
		AjaxZip3.onSuccess = function() {
			$('.your-address').focus();
		};
		//失敗時に実行する処理
		AjaxZip3.onFailure = function() {
			alert('郵便番号に該当する住所が見つかりません');
		};
		return false;
	});

  // Auto kana
  if ($('#your-name').length) {
    $.fn.autoKana('#your-name', '#your-ruby');
  }

	//フェードインで表示（セクション）
	$(window).scroll(function (){
		$('.fadein').each(function(){
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight + 200){
				$(this).addClass('scrollin');
			}
		});
	});

});